import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { PanelEditor } from "../panels/PanelEditor.tsx";
import { DEFAULT_DOCUMENT_ID } from "../lib/documentsRegistry.ts";

/**
 * Lokalt läge för Centralspec. All data i webbläsarens IndexedDB via Yjs —
 * ingen backend, ingen inloggning. URL:ens documentId mappar 1:1 mot en egen
 * Y.Doc så flera centraler kan öppnas parallellt i olika flikar.
 */
export function LocalPanelRoute() {
  const params = useParams();
  const navigate = useNavigate();
  const rawId = params.documentId ?? DEFAULT_DOCUMENT_ID;
  const documentId = sanitizeId(rawId);

  const onSwitchDocument = useCallback(
    (id: string) => {
      if (id === DEFAULT_DOCUMENT_ID) navigate("/local");
      else navigate(`/local/${encodeURIComponent(id)}`);
    },
    [navigate],
  );

  return (
    <div className="flex h-screen w-screen flex-col">
      <div className="min-h-0 flex-1">
        <PanelEditor
          key={documentId}
          documentId={documentId}
          onSwitchDocument={onSwitchDocument}
        />
      </div>
    </div>
  );
}

function sanitizeId(id: string): string {
  const cleaned = id.replace(/[^a-zA-Z0-9_-]/g, "");
  return cleaned.length > 0 ? cleaned : DEFAULT_DOCUMENT_ID;
}
